import moment from "moment";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../component/Loader";
import { details, FetchUserDetail } from "./UserSlice";
import BackButton from "./../../component/BackButton";
import { FetchConsentList } from "../consent/ConsentSlice";
import { IoIosAddCircle } from "react-icons/io";
import { FaMinus } from "react-icons/fa";
import { postFormData } from "../../api/index.js";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';



function ViewUser() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const data = useSelector((state) => state.user.detail);
  const [loading, setLoading] = useState(false);
  const [consents, setConsents] = useState([]);
  const navigate = useNavigate();
  const consentList = useSelector((state) => state.consent.list);
  const [consnetToggle, setConsentToggle] = useState(false);

  useEffect(() => {
    dispatch(FetchConsentList({ page: 1, limit: 100000 }));
  }, [dispatch]);

  const handleAnonymizeUser = () => {
    postFormData("user/anonymizeUser", {
      userId: data?.id
    }).then((res) => {
      if (res?.code === 1) {
        toast.success(res?.message, {  autoClose: false,  closeButton: true});
        getDetails();
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };
  const handleActiveInactiveUser = () => {
    postFormData("user/activeInactiveUser", {
      userId: data?.id,
      status: data?.isActive == 1 ? 0 : 1
    }).then((res) => {
      if (res?.code === 1) {
        toast.success(res?.message, {  autoClose: false,  closeButton: true});
        getDetails();
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  const handleAnonymizeStudent = (studentId) => {
    postFormData("user/anonymizeStudent", {
      studentId
    }).then((res) => {
      if (res?.code === 1) {
        toast.success(res?.message, {  autoClose: false,  closeButton: true});
        getDetails();
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };
  const handleActiveInactiveStudent = (studentId, status) => {
    postFormData("user/activeInactiveStudent", {
      studentId,
      status
    }).then((res) => {
      if (res?.code === 1) {
        toast.success(res?.message, {  autoClose: false,  closeButton: true});
        getDetails();
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };


  const getDetails = useCallback(() => {
    setLoading(true);
    dispatch(FetchUserDetail({ userId: id })).then((res) => {
      if (res?.payload?.code === 1) {
        setLoading(false);
      }
    });
  }, [dispatch, id]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  useEffect(() => {
    return () => {
      dispatch(details(null));
    };
  }, [dispatch]);

  if (loading) {
    return (
      <article className="col-lg-9 articleClass">
        <Loader />
      </article>
    );
  } else {
    return (
      <article className="col-lg-9 articleClass">
        <div className="article-body store-bd-gy">
          <div className="row align-items-center col-rever">
            <BackButton />
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
              <h3>User Details</h3>
            </div>
            <div className="col-sm-12 text-end px-md-5">
              <button
                type="button"
                className="btn p-3 fs-6" style={{'float':'left', 'color':'red'}}
                onClick={(e) => {
                  e.preventDefault(); // Prevent the default link behavior
                  Swal.fire({
                    title: 'Confirm to Anonymize',
                    text: 'You have the right to request deletion or anonymisation of your data. However, some data must be kept for legal reasons, such as Ofsted requirements. If you’d like us to anonymize your data, please click below.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      handleAnonymizeUser()
                    }
                  });
                }}
              >
                <i class="fa fa-trash" aria-hidden="true"></i>{" "}Anonymize Account 
              </button>
              <button
                type="button"
                className="btn p-3 fs-6" style={{'float':'left'}}
                onClick={(e) => {
                  e.preventDefault(); // Prevent the default link behavior
                  Swal.fire({
                    title: data?.isActive == 0 ? 'Confirm to Activate' : 'Confirm to Deactivate',
                    text: data?.isActive == 0 ? 'Are you sure you want to activate this account?' : 'Are you sure you want to deactivate this account?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      handleActiveInactiveUser()
                    }
                  });
                }}
              >
                {data?.isActive == 1 && <i class="fa fa-ban" aria-hidden="true"></i>} 
                {data?.isActive == 1 ? ' Deactivate Account' : 'Activate Account'} 
              </button>
              <button
                type="button"
                className="btn btn-save p-3 fs-6"
                onClick={() => {
                  navigate(`/user/${id}/wallet/${data?.wallet}`);
                }}
              >
                Wallet <i class="fa fa-gbp" aria-hidden="true"></i>{" "}
                {data?.wallet}
              </button>
            </div>
          </div>
          <div className="row mt-3 px-md-5">
            <div className="col-sm-12 mb-3">
              <h3>Account Holder Details</h3>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3  position-relative h-100">
                <p className="text-capitalize mb-1">full name</p>
                <h6 className="">
                  <img
                    src="assets/images/First-Name.png"
                    className="detail-icon"
                    alt=""
                  />
                  {data?.first_name
                    ? data?.first_name + " " + data?.last_name
                    : ""}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3  position-relative h-100">
                <p className="text-capitalize mb-1">username</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/First-Name.png"
                    className="detail-icon"
                    alt=""
                  />
                  {data?.username || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3  position-relative h-100">
                <p className="text-capitalize mb-1">email ID</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/Email-Address.png"
                    className="detail-icon"
                    alt=""
                  />
                  {data?.email || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3  position-relative h-100">
                <p className="text-capitalize mb-1">Contact Number</p>
                <h6 className="">
                  <img
                    src="assets/images/address.png"
                    className="detail-icon"
                    alt=""
                  />
                  {data?.address_details?.mobile
                    ? data?.address_details?.countryCode +
                      data?.address_details?.mobile
                    : "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3  position-relative h-100">
                <p className="text-capitalize mb-1">date of birth</p>
                <h6 className="">
                  <img
                    src="assets/images/Date-of-Birth.png"
                    className="detail-icon"
                    alt=""
                  />
                  {data?.address_details?.dob &&
                  data?.address_details?.dob !== "0000-00-00"
                    ? moment(data?.address_details?.dob).format("DD MMM YYYY")
                    : data?.address_details?.dob_year
                    ? moment(
                        `${data?.address_details?.dob_year}-${data?.address_details?.dob_month}-${data?.address_details?.dob_day}`
                      ).format("DD MMM YYYY")
                    : "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3  position-relative h-100">
                <p className="text-capitalize mb-1">full address</p>
                <h6 className="">
                  <img
                    src="assets/images/address.png"
                    className="detail-icon"
                    alt=""
                  />
                  {data?.address_details
                    ? `${
                        data?.address_details?.property_number
                          ? `${data?.address_details?.property_number}, `
                          : ""
                      }${
                        data?.address_details?.property_name
                          ? `${data?.address_details?.property_name}, `
                          : ""
                      }${
                        data?.address_details?.street_number
                          ? `${data?.address_details?.street_number}, `
                          : ""
                      }${
                        data?.address_details?.town
                          ? `${data?.address_details?.town}, `
                          : ""
                      }${
                        data?.address_details?.country
                          ? `${data?.address_details?.country}`
                          : ""
                      }${
                        data?.address_details?.postal_code
                          ? `-${data?.address_details?.postal_code}`
                          : ""
                      }`
                    : "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <div
                className="bg-white px-5 py-3  position-relative h-100"
                style={{
                  textTransform: "uppercase",
                }}
              >
                <div className="d-flex">
                  <h5 className="mb-1">
                    {data?.consent?.length > 1 ? "Consents" : "Consent"}
                  </h5>
                  <span
                    className="ms-auto cursor-pointer"
                    onClick={() => setConsentToggle(!consnetToggle)}
                  >
                    {consnetToggle ? (
                      <FaMinus size={35} />
                    ) : (
                      <IoIosAddCircle size={35} />
                    )}
                  </span>
                </div>
                {data?.consent?.length > 0
                  ? consnetToggle &&
                    data?.consent?.map((item, i) => {
                      return (
                        <>
                          <p>
                            <span>{item?.consent_details?.label}: </span>
                            <span className="fw-bold">{item?.value}</span>
                          </p>
                          {item?.consent_details?.label
                            ?.toLowerCase()
                            ?.includes("medication prescribed") &&
                            item?.note && (
                              <p>
                                <span>Medication: </span>
                                <span className="fw-bold">{item?.note}</span>
                              </p>
                            )}
                        </>
                      );
                    })
                  : consnetToggle && (
                      <p className="text-muted">No consents found</p>
                    )}
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <hr />
            </div>

            <div className="col-sm-12 mb-3">
              <h3>Students</h3>
            </div>
            {data?.student_list?.length > 0 ? (
              <div className="table-responsive" style={{overflowX: 'auto'}}>
                <table className="table table-hover table-striped bg-white" style={{minWidth: '1200px'}}>
                  <thead className="table-light">
                    <tr>
                      <th>Name</th>
                      <th>Gender</th>
                      <th>Membership</th>
                      <th>DOB</th>
                      <th>Activity</th>
                      <th>Location</th>
                      <th>Contact</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.student_list?.map((item, i) => {
                      return (
                        <tr key={i} className="border-bottom">
                          <td className="py-3">
                            <div className="d-flex align-items-left">
                              <div className="avatar-sm bg-light rounded-circle d-flex align-items-center justify-content-left me-2">
                                <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                                </svg>
                              </div>
                              <a 
                                href={`/student/${item?.id}`}
                                className="fw-bold active text-decoration-none"
                                style={{cursor: 'pointer'}}
                              >
                                {item?.first_name
                                  ? item?.first_name + " " + item?.last_name
                                  : "NA"}
                              </a>
                            </div>
                          </td>
                          <td className="py-3 ">{item?.gender || "NA"}</td>
                          <td className="py-3">
                            <span className={`badge ${
                              item?.membership_details
                                ? 'bg-success'
                                : item?.trialAccountStatus === "1"
                                ? 'bg-info'
                                : item?.trialAccountStatus === "2"
                                ? 'bg-warning'
                                : 'bg-secondary'
                            } text-white`}>
                              {item?.membership_details
                                ? item?.membership_details?.membership_details?.name
                                : item?.trialAccountStatus === "1"
                                ? "Trial"
                                : item?.trialAccountStatus === "2"
                                ? "Trial Expired"
                                : "No Membership"}
                            </span>
                          </td>
                          <td className="py-3 ">
                            {item?.dob
                              ? moment(item?.dob).format("DD MMM YYYY")
                              : item?.dob_year
                              ? moment(
                                  `${item?.dob_year}-${item?.dob_month}-${item?.dob_day}`
                                ).format("DD MMM YYYY")
                              : "NA"}
                          </td>
                          <td className="py-3 ">
                            {item?.discipline_details
                              ? item?.discipline_details?.name
                              : "NA"}
                          </td>
                          <td className="py-3">
                            <small className="">
                              {item?.school_details
                                ? `${item?.school_details?.name}, ${item?.school_details?.areacode_details?.areacode}`
                                : ""}
                            </small>
                          </td>
                          <td className="py-3 ">
                            {item?.emergency_contactNo
                              ? item?.emergency_countryCode + item?.emergency_contactNo
                              : "NA"}
                          </td>
                          <td className="py-3">
                            <div className="d-flex gap-1 justify-content-center">
                              <button
                                type="button"
                                className="btn"
                                onClick={() => {
                                  window.location.href = `/student/${item?.id}`;
                                }}
                                title="View Details"
                              >
                                <img
                                  src="assets/images/view.png"
                                  alt=""
                                />
                              </button>
                              <button
                                type="button"
                                className="btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  Swal.fire({
                                    title: 'Confirm to Anonymize',
                                    text: 'You have the right to request deletion or anonymisation of your data. However, some data must be kept for legal reasons, such as Ofsted requirements. If you would like us to anonymize your data, please click below.',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Yes',
                                    cancelButtonText: 'No',
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      handleAnonymizeStudent(item?.id)
                                    }
                                  });
                                }}
                                title="Anonymize Student"
                              >
                                <img
                                  src="assets/images/delete.png"
                                  alt=""
                                />
                              </button>
                              <div className="form-check form-switch mt-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`switch-${item?.id}`}
                                  checked={item?.isActive == 1}
                                  onChange={(e) => {
                                    e.preventDefault();
                                    Swal.fire({
                                      title: item?.isActive == 0 ? 'Confirm to Activate' : 'Confirm to Deactivate',
                                      text: item?.isActive == 0 ? 'Are you sure you want to activate this student?' : 'Are you sure you want to deactivate this student?',
                                      icon: 'warning',
                                      showCancelButton: true,
                                      confirmButtonText: 'Yes',
                                      cancelButtonText: 'No',
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        handleActiveInactiveStudent(item?.id, item?.isActive ? 0 : 1)
                                      }
                                    });
                                  }}
                                  title={item?.isActive == 1 ? 'Deactivate Student' : 'Activate Student'}
                                  style={{backgroundColor: item?.isActive == 1 ? '#0d6efd' : '', borderColor: item?.isActive == 1 ? '#0d6efd' : ''}}
                                />
                                <label className="form-check-label" htmlFor={`switch-${item?.id}`}>
                                  {item?.isActive == 1 ? 'Active' : 'Inactive'}
                                </label>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 bg-white">
                <div className="">
                  <svg width="48" height="48" fill="currentColor" viewBox="0 0 24 24" className="mb-3">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                  <p className="mb-0">No students found.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </article>
    );
  }
}

export default ViewUser;
